const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

const initialState = {
  currentPageHeading: 'Users',
  currentContext: null
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      let context = null
      if (action.payload.pathname !== '/' && action.payload.pathname !== '/callback') {
        let parsedPathName = action.payload.pathname.split('/')[1]
        parsedPathName = parsedPathName[0].toUpperCase() + parsedPathName.substring(1)
        if (action.payload.state && action.payload.state.name) {
          context = action.payload.state.name
        }
        return {
          ...state,
          currentPageHeading: parsedPathName,
          currentContext: context
        }
      }
      return {...state}
    default:
      return state
  }
}

export default reducer
